import { useState, useEffect, useRef } from 'react';
import { fillForm } from '../../config/configuration/react';

export default function useValue(
  formIdInit,
  sectionId,
  questionId,
  questionType,
  typeValue,
  defaultValue = null,
  questionChild = null,
  questionChiledType = null,
) {
  const formId = parseInt(formIdInit, 10);
  const [value, setValue] = useState(null);
  const path = `inspection.children.${sectionId}.children.${questionId}.${typeValue}`;
  let defaultPath = false;
  const isMounted = useRef(false);
  if (defaultValue !== null && defaultValue !== undefined) {
    const sectionAndQuestionDefault = defaultValue.split('.');
    defaultPath = `inspection.children.${sectionAndQuestionDefault[0]}.children.${sectionAndQuestionDefault[1]}.${typeValue}`;
  }

  // register value in db.forms
  const registerValue = async (input) => {
    await fillForm.saveValue(formId, path, input, questionId, questionType, questionChild, questionChiledType);
    setValue(input);
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: `${sectionId}.${questionId}`,
      }),
    );
  };

  const refreshValue = async () => {
    let storedValue = await fillForm.getValue(formId, path);
    if (storedValue === null && defaultPath) {
      storedValue = await fillForm.getValue(formId, defaultPath);
      if (storedValue) registerValue(storedValue);
    }
    if (!isMounted.current) {
      setValue(storedValue);
    }
  };

  // init the value
  useEffect(() => {
    refreshValue();
    return () => {
      isMounted.current = true;
    };
  }, [path]);

  return [value, registerValue, refreshValue];
}
